<template>
<div class="sku_con">
	<el-table :data="spus" border style="width:95.2%;margin:0px auto;" size="medium" >
	    <!-- <el-table-column
        type="selection"
        width="50">
      </el-table-column> -->

      <!-- <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="110">
      </el-table-column> -->

      <el-table-column
        prop="article_id"
        label="账号"
        width="110">
      </el-table-column>
      <el-table-column prop="title" label="文章名称"></el-table-column>
	    <el-table-column prop="name" label="作者"></el-table-column>
	    <el-table-column prop="channel_name" width='100' label="所属频道"></el-table-column>
      <el-table-column prop="comment_count" width='100' label="评论数"></el-table-column>
      <el-table-column prop="update_time" width='110' label="更新时间"></el-table-column>
      <el-table-column width='100' label="状态">
        <template slot-scope="scope">
          <!-- {{scope.row.status}} -->
          <!--  0 1 2 3 4 5  -->
          <span v-if="scope.row.status==0">草稿</span>
          <span v-else-if="scope.row.status==1">待审核</span>
          <span v-else-if="scope.row.status==2">审核通过</span>
          <span v-else-if="scope.row.status==3">审核失败</span>
          <span v-else-if="scope.row.status==4">已删除</span>
          <span v-else-if="scope.row.status==5">封禁</span>
        </template>
      </el-table-column>
      <el-table-column
	      label="操作"
        width='200'>
	        <template slot-scope="scope">
	          <!-- <el-button size="mini">
               <router-link :to='{name:"SpuEdit",params:{sEdit_id:scope.row.id}}'>查看</router-link>
            </el-button>
             -->
            <el-button
              size="mini"
              @click="fnPopShow(scope.row.article_id)">查看</el-button>
            <el-button
              v-if=''
              size="mini"
              type="danger"
              @click="fnDelSpu(scope.row.article_id, scope.row.status)">{{scope.row.status==5?'解禁':'封禁'}}</el-button>
	          <el-button
	            size="mini"
	            type="danger"
	            @click="fnDelSpu(scope.row.article_id, 4)">删除</el-button>
	        </template>
	    </el-table-column>
	 </el-table>

   <el-dialog title="内容详情" :visible.sync="pop_show" append-to-body width="60%">
        <el-form :model="skuForm" :inline="true" status-icon ref="userForm" label-width="100px">
          <el-form-item label="标题:" prop="title">
            <el-input type="text" style='width: 260%'  v-model="skuForm.title" autocomplete="off" size="small"></el-input>
          </el-form-item><br>
          <el-form-item label="作者:" prop="name">
            <el-input type="text"v-model="skuForm.name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="所属频道:" prop="channel_name">
            <el-input type="text" v-model="skuForm.channel_name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="评论数:" prop="comment_count">
            <el-input type="text" v-model="skuForm.comment_count" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" prop="update_time">
            <el-input type="text" v-model="skuForm.update_time" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态:" prop="status">
            <el-input type="text" v-model="skuForm.status" autocomplete="off" size="small"></el-input>
          </el-form-item><br>
          <el-form-item label="文章详情:" prop="content">
            <!-- <el-input style='width: 270%' type="textarea" :rows="8" v-model="skuForm.content" autocomplete="off" size="small"></el-input> -->
            <div class="content" v-html='skuForm.content'></div>
          </el-form-item>
        </el-form>
      </el-dialog>
</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'SkuTable',
  props:['spus', 'nowPage'],
  data () {
    return {
      pop_show:false,
      edit_id:'',
      skuForm:{
        "title": "",
        "name": "",
        "channel_name": "",
        "comment_count": 0,
        "update_time": "",
        "status": 0,
        "content": ""
      },
      category_list:[],
      goods_list:[],
      specs_list:[]
    }
  },
  methods:{
    indexMethod(index) {
      return (this.nowPage - 1)* 10 + index+1
    },
    fnPopShow(id){
      let token = localStorage.token;
      this.pop_show = true
      this.edit_id = id
      this.axios.get(cons.apis + '/v1_0/articles/'+id, {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.skuForm = dat.data.data;

      }).catch(err=>{
         console.log(err.response);
      });
    },
    fnDelSpu(id, stu){
        if(stu==2){
          stu = 5
        }else if(stu==5){
          stu = 6
        }else if(stu==6){
          stu = 5
        }
        let token = localStorage.token;
        this.edit_id = id;
        this.$confirm('是否确定此修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.put(cons.apis + '/v1_0/articles',{
                "article_ids": [this.edit_id],  // 文章id列表
                "status": stu // 需要修改的审核状态 5封禁 6解封 2通过审核 3驳回(审核失败) 4删除
              },{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==403){
               this.$message({
                  type:'error',
                  message:err.response.data.message
               });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
}
</script>
<style>
	.el-button+.el-button{
		margin-left:0px;
		margin-top:10px;
	}
  .el-button--default a{
    display:block;
    color:#606266;
    width:65px;
    line-height:42px;
    margin:-15px -20px;
  }

  .content {
    padding: 0 140px 0 100px;
  }


</style>



// WEBPACK FOOTER //
// src/components/widget/ContentTable.vue